<template>
  <el-popover :placement="'right'" width="auto" trigger="click" style="padding: 0 !important;">
    <div class="remark-popover-header el-card__header">
      <span>{{ $t('remark') }}</span>
      <el-button type="success" size="mini" style="float: right; top: -3px; position: relative"
                 @click="onEditRemarkButtonClick">
        {{ $t('edit') }}
      </el-button>
    </div>
    <div class="remark-popover-body">
      <popover-container :loadingStatus="isLoading">
        <div class="editor-preview" v-html="bindRemark()"></div>
      </popover-container>
    </div>
    <el-button type="primary" size="mini" plain slot="reference"
               @click="onPreviewRemarkButtonClick()">
      <i class="el-icon-info"></i> {{ $t('remark') }}
    </el-button>
  </el-popover>
</template>

<script>
import { get } from 'lodash'
import i18nMessages from '@/translations/Hotel/components/PopoverPreviewRemarkComponent.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import PopoverContainer from '@/components/PopoverContainerComponent.vue'
import RemarkApi from '@/api/hotel/remark-api'
import { REMARK_TYPE } from '@/configs/constant'
import { mapState } from 'vuex'

export default {
  name: 'PopoverPreviewRemarkComponent',
  mixins: [AlertViewMixin],
  components: { PopoverContainer },
  i18n: { messages: i18nMessages },
  props: {
    remarkType: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      activeHotelId: state => state.general.activeHotelId
    })
  },
  data () {
    return {
      REMARK_TYPE,
      isLoading: false,
      remarkContent: ''
    }
  },
  methods: {
    onPreviewRemarkButtonClick: async function () {
      this.isLoading = true

      try {
        const remark = await RemarkApi.detail(this.activeHotelId, this.remarkType)
        this.remarkContent = get(remark, 'content', '')
      } catch (err) {
        this.alertError(err.message)
      }

      this.isLoading = false
    },
    onEditRemarkButtonClick: function () {
      let routerName = ''

      switch (this.remarkType) {
        case REMARK_TYPE.RATE_CODE:
          routerName = 'HotelRateCodeRemark'
          break
        case REMARK_TYPE.SUPPLEMENT:
          routerName = 'HotelSupplementItemRemark'
          break
        case REMARK_TYPE.PROMOTION:
          routerName = 'HotelPromotionRemark'
          break
        case REMARK_TYPE.TRANSFER:
          routerName = 'HotelTransferRemark'
          break
      }

      this.$router.push({
        name: routerName,
        params: {
          hotelId: this.activeHotelId,
          remarkContent: this.remarkContent
        }
      })
    },
    bindRemark: function () {
      const result = this.remarkContent.replace(/(?:\r\n|\r|\n)/g, '<br>')
      return result
    }
  }
}
</script>

<style scoped>
  .remark-popover-header {
    padding: 10px;
    border-bottom: 1px solid #EBEEF5;
    font-size: 15px;
    background-color: #f8f9fa;
  }
  .remark-popover-body {
    padding: 10px;
  }
</style>
